<template>
  <div class="team-list bg-white shadow-sm">
    <div class="team-list-header">
      <h4 class="team-list-title text-center">Directory</h4>
      <div class="mt-3 mb-4">
        <b-input autocomplete="off" class="form-control-gray" placeholder="Search team or member" @input="onQuery" />
      </div>
    </div>
    <div v-if="!loading" class="team-list-content">
      <team-item
        v-for="team in teams"
        :key="team.id"
        :team="team"
        :profiles="profiles"
        :me-profile="meProfile"
        :is-admin="isAdmin"
        class="mb-4"
        @team-give-kudo="$emit('team-give-kudo', $event)"
        @team-send-message="$emit('team-send-message', $event)"
        @member-give-kudo="$emit('member-give-kudo', $event)"
        @member-send-message="$emit('member-send-message', $event)"
        @invite-users="$emit('invite-users', $event)"
      />
    </div>
    <div v-else class="text-center p-5">
      <b-spinner variant="primary" label="Loading..." />
    </div>
  </div>
</template>

<script>
import TeamItem from './TeamItem.vue'

export default {
  name: 'Directory',

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    teams: {
      type: Array,
      default: () => ([])
    },

    profiles: {
      type: Object,
      default: () => ({})
    },

    meProfile: {
      type: Number
    },

    isAdmin: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onQuery(query) {
      this.$emit('search', query)
    }
  },

  components: {
    TeamItem
  }
}
</script>
